export function getServiceLocationBase() {
	return "http://3.129.254.135:8750/wl";
	//return "http://localhost:8750/wl";
	//return "http://18.218.170.235:8755";
}

export function getWlcServiceLocationBase() {
	return "http://3.129.254.135:8750/wl";
	//return "http://localhost:8750/wl";
	//return "http://18.218.170.235:8750/wl";
}

export function getPokerServiceLocationBase() {
	return "http://3.129.254.135:8750/wl/poker";
	//return "http://localhost:8750/wl/poker";
	//return "http://18.218.170.235:8755/poker";
}

export function getPoolsServiceLocationBase() {
	return "http://localhost:8080/data/pools";
	//return "http://localhost:8765/reference/general/pools/mr21044";
}

export function getCardsServiceLocationBase() {
	return "http://localhost:8750/acme/deck";
	//return "http://localhost:8765/reference/general/pools/mr21044";
}

export function getWebsocketsServiceLocationBase() {
	return "http://restservices.remindertabs.com:8750/wl/websocket";
}
